import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const trackEvent = async (eventData) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      // Skip tracking for unauthenticated users silently
      return;
    }
    await axios.post(`${API_URL}/analytics/track`, eventData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  } catch (error) {
    // Silently fail analytics - don't clutter console
    if (error.response?.status !== 401) {
      console.debug('Analytics tracking skipped:', error.message);
    }
  }
};

export const trackAppSwitch = (appName) => {
  trackEvent({
    app_name: appName,
    action: 'app_switch',
    metadata: {
      from_page: window.location.pathname
    }
  });
};

export const trackFeatureUse = (appName, featureName) => {
  trackEvent({
    app_name: appName,
    action: 'feature_use',
    feature_name: featureName
  });
};

export const trackPageView = (appName, pagePath) => {
  trackEvent({
    app_name: appName,
    action: 'page_view',
    page_path: pagePath
  });
};

export const getAnalyticsStats = async (days = 30) => {
  try {
    const response = await axios.get(`${API_URL}/analytics/stats`, {
      params: { days },
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching analytics:', error);
    return null;
  }
};